// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"f8b6aba3","222":"1bc129da","550":"ab0ea1dc","787":"0f953cb8","842":"24ca7d90","917":"076a5f5d"}[chunkId] + ".chunk.js";
};